import { useSelector } from "react-redux";

export default function useHasPermissionForRoute() {
    const { user } = useSelector((state) => state.auth);
    return user?.permissions || [];
  }